export default function NotFound() {
    return (
        <>
            <h1>404 Not Found</h1>
            <div style={{ width: "100%", marginBottom: "40px" }}>
                <a href="/">주문 접수로 이동</a>
            </div>
        </>
    )
}